"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCompany = createCompany;
exports.deleteCompany = deleteCompany;
exports.getCompanyDetail = getCompanyDetail;
exports.getCompanyList = getCompanyList;
exports.getCompanySimpleList = getCompanySimpleList;
exports.updateCompany = updateCompany;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BASE_URL = '/admin/merchant/statement/company';

/**
 * 分页列表
 * @param {Object} params - { page, limit, companyName, taxNo }
 */
function getCompanyList(params) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/list"),
    method: 'GET',
    params: params
  });
}

/**
 * 不分页列表（用于下拉选择）
 */
function getCompanySimpleList() {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/list"),
    method: 'GET'
  });
}

/**
 * 详情
 * @param {number} id
 */
function getCompanyDetail(id) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/detail/").concat(id),
    method: 'GET'
  });
}

/**
 * 新增
 * @param {Object} data - { companyName, taxNo, registeredAddress, userCreatedAt }
 */
function createCompany(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/create"),
    method: 'POST',
    data: data
  });
}

/**
 * 更新
 * @param {Object} data - { id, companyName, taxNo, registeredAddress, userCreatedAt }
 */
function updateCompany(data) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/update"),
    method: 'POST',
    data: data
  });
}

/**
 * 删除
 * @param {number} id
 */
function deleteCompany(id) {
  return (0, _request.default)({
    url: "".concat(BASE_URL, "/delete/").concat(id),
    method: 'DELETE'
  });
}